module.exports = [
  {
    name: 'en_GB',
    lang: 'en',
    sourceFile: null,
    isDefault: true,
  },
  {
    name: 'es_SP',
    lang: 'es',
    sourceFile: 'locales/es_SP.po',
  },
  {
    name: 'pt_PT',
    lang: 'pt',
    sourceFile: 'locales/pt_PT.po',
  },
];



// WEBPACK FOOTER //
// ./config/locales.js